/* Wanderest One-Product Theme — theme.js */
(function () {
  'use strict';

  var SV = window.SV || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    format = format || SV.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var m = format.match(placeholder);
    var value = '';
    switch (m ? m[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = fmt(cents, 2, ' ', '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  SV.formatMoney = formatMoney;

  function prefersReduced() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Click ripple on every button */
  function initRipple() {
    document.addEventListener('pointerdown', function (e) {
      if (prefersReduced()) return;
      var btn = e.target.closest && e.target.closest('.btn');
      if (!btn || btn.disabled) return;
      var r = btn.getBoundingClientRect();
      var size = Math.max(r.width, r.height) * 2;
      var dot = document.createElement('span');
      dot.className = 'btn__ripple';
      dot.style.width = dot.style.height = size + 'px';
      dot.style.left = (e.clientX - r.left - size / 2) + 'px';
      dot.style.top = (e.clientY - r.top - size / 2) + 'px';
      btn.appendChild(dot);
      setTimeout(function () { if (dot.parentNode) dot.parentNode.removeChild(dot); }, 700);
    }, { passive: true });
  }

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function lockScroll(lock) { document.body.classList.toggle('no-scroll', !!lock); }

  /* ---------------- Mobile menu ---------------- */
  function initMenu() {
    var menu = $('[data-menu]');
    if (!menu) return;
    $$('[data-menu-open]').forEach(function (b) {
      b.onclick = function () { menu.hidden = false; b.setAttribute('aria-expanded', 'true'); lockScroll(true); };
    });
    $$('[data-menu-close]', menu).forEach(function (b) {
      b.onclick = function () { menu.hidden = true; lockScroll(false); $$('[data-menu-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); }); };
    });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { menu.hidden = true; lockScroll(false); }); });
  }

  /* ---------------- Announcement rotator ---------------- */
  function initRotator() {
    $$('[data-rotator]').forEach(function (wrap) {
      var msgs = $$('.announcement__msg', wrap);
      if (msgs.length < 2 || wrap.dataset.init) return;
      wrap.dataset.init = '1';
      var i = 0;
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, 4000);
    });
  }

  /* ---------------- Gallery ---------------- */
  function initGallery(root) {
    var gallery = $('[data-gallery]', root);
    if (!gallery) return null;
    var track = $('[data-gallery-track]', gallery);
    var slides = $$('.gallery__slide', track);
    var thumbs = $$('[data-thumb]', gallery);
    var dots = $$('.gallery__dot', gallery);
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
      var t = thumbs[i];
      if (t && t.parentNode) {
        var p = t.parentNode;
        var left = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    function goTo(i) {
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        if (i !== current) setActive(i);
      });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.dataset.thumb, 10)); }); });
    var prev = $('[data-gallery-prev]', gallery), next = $('[data-gallery-next]', gallery);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    return {
      goToMedia: function (mediaId) {
        var idx = slides.findIndex(function (s) { return s.dataset.mediaId == String(mediaId); });
        if (idx > -1) goTo(idx);
      }
    };
  }

  /* ---------------- Countdown ---------------- */
  function initCountdowns(root) {
    $$('[data-countdown]', root).forEach(function (el) {
      if (el.dataset.init) return;
      el.dataset.init = '1';
      var raw = (el.dataset.countdown || '').trim().replace(' ', 'T');
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) raw += 'T23:59';
      var end = new Date(raw).getTime();
      if (!end || isNaN(end)) return;
      var d = $('[data-cd-d]', el), h = $('[data-cd-h]', el), m = $('[data-cd-m]', el), s = $('[data-cd-s]', el);
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var diff = end - Date.now();
        if (diff <= 0) { el.hidden = true; clearInterval(timer); return; }
        el.hidden = false;
        var sec = Math.floor(diff / 1000);
        d.textContent = pad(Math.floor(sec / 86400));
        h.textContent = pad(Math.floor((sec % 86400) / 3600));
        m.textContent = pad(Math.floor((sec % 3600) / 60));
        s.textContent = pad(sec % 60);
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------------- Product hero ---------------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root);
    var form = $('[data-product-form]', root);
    if (!jsonEl || !form) return;
    if (form.dataset.init) return;
    form.dataset.init = '1';

    var product, inventory = {};
    try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    try { inventory = JSON.parse($('[data-inventory-json]', root).textContent); } catch (e) { inventory = {}; }
    var gallery = initGallery(root);
    var variantInput = $('[data-variant-input]', form);
    var qtyInput = $('[data-qty-input]', form);
    var atc = $('[data-atc]', form);
    var atcText = $('[data-atc-text]', form);
    var atcDefault = atcText ? atcText.textContent : SV.strings.addToCart;
    var buyNow = $('[data-buy-now]', form);
    var errorEl = $('[data-form-error]', form);
    var bundles = $('[data-bundles]', form);
    var tiers = bundles ? $$('[data-tier]', bundles) : [];
    var stickyBar = $('[data-sticky-atc]', root);
    var stickyPrice = $('[data-sticky-price]', root);

    var currentVariant = product.variants.find(function (v) { return String(v.id) === variantInput.value; }) || product.variants[0];

    function selectedTier() { return tiers.find(function (t) { return t.checked; }) || null; }

    function tierQty(t) { return t ? Math.max(1, parseInt(t.dataset.qty, 10) || 1) : 1; }

    function updateTierPrices() {
      if (!bundles || bundles.dataset.mode === 'variant') return;
      var base = currentVariant.price;
      var compare = Math.max(currentVariant.compare_at_price || 0, base);
      tiers.forEach(function (t) {
        var label = t.closest('.tier');
        var q = tierQty(t), pct = parseInt(t.dataset.pct, 10) || 0;
        var price = Math.floor(base * q * (100 - pct) / 100);
        var cmp = compare * q;
        var p = $('[data-tier-price]', label), c = $('[data-tier-compare]', label), s = $('[data-tier-save]', label);
        if (p) p.textContent = formatMoney(price);
        if (c) c.textContent = formatMoney(cmp);
        if (s) s.textContent = formatMoney(cmp - price);
        var pc = $('[data-tier-pct]', label);
        if (pc && cmp > 0) pc.textContent = Math.floor((cmp - price) * 100 / cmp);
      });
    }

    function currentTotal() {
      var t = selectedTier();
      if (!t) return currentVariant.price;
      if (t.dataset.variantId) {
        var v = product.variants.find(function (x) { return String(x.id) === t.dataset.variantId; });
        return v ? v.price : currentVariant.price;
      }
      var q = tierQty(t), pct = parseInt(t.dataset.pct, 10) || 0;
      return Math.floor(currentVariant.price * q * (100 - pct) / 100);
    }

    function currentCompare() {
      var t = selectedTier();
      var cmpUnit = Math.max(currentVariant.compare_at_price || 0, currentVariant.price);
      if (!t) return cmpUnit;
      if (t.dataset.variantId) {
        var cEl = $('[data-tier-compare]', t.closest('.tier'));
        return cEl ? null : cmpUnit;
      }
      return cmpUnit * tierQty(t);
    }
    function refreshSticky() {
      if (stickyPrice) stickyPrice.textContent = formatMoney(currentTotal());
      var sc = stickyBar ? $('[data-sticky-compare]', stickyBar) : null;
      if (sc) {
        var c = currentCompare();
        sc.hidden = !(c && c > currentTotal());
        if (c) sc.textContent = formatMoney(c);
      }
    }

    function onTierChange() {
      tiers.forEach(function (t) { t.closest('.tier').classList.toggle('is-selected', t.checked); });
      var t = selectedTier();
      qtyInput.value = t && !t.dataset.variantId ? tierQty(t) : 1;
      refreshSticky();
    }
    tiers.forEach(function (t) { t.addEventListener('change', onTierChange); });
    if (tiers.length) onTierChange();

    function setAvailability(v) {
      if (!atc) return;
      atc.disabled = !v || !v.available;
      if (buyNow) buyNow.disabled = atc.disabled;
      if (atcText) atcText.textContent = v && v.available ? atcDefault : SV.strings.soldOut;
    }

    function updatePrice(v) {
      var wrap = $('[data-price-wrap]', root);
      if (!wrap) return;
      var priceEl = $('[data-price]', wrap), cmpEl = $('[data-compare]', wrap), saveEl = $('[data-save]', wrap);
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      var onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (cmpEl) { cmpEl.textContent = onSale ? formatMoney(v.compare_at_price) : ''; cmpEl.hidden = !onSale; }
      if (saveEl) {
        var badgeEl = saveEl.closest('.badge') || saveEl;
        badgeEl.hidden = !onSale;
        if (onSale) saveEl.textContent = 'SAVE ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
      }
    }

    function updateStock(v) {
      var el = $('[data-stock]', root);
      if (!el) return;
      var txt = $('[data-stock-text]', el);
      var threshold = parseInt(el.dataset.threshold, 10) || 0;
      var inv = inventory[String(v.id)] || {};
      var qty = typeof inv.q === 'number' ? inv.q : null;
      var low = inv.m === 'shopify' && qty !== null && qty > 0 && qty <= threshold;
      el.classList.toggle('stock--low', low);
      if (txt) txt.textContent = low ? el.dataset.lowText.replace('[count]', qty) : el.dataset.inText;
    }

    // Variant picker
    var picker = $('[data-variant-picker]', root);
    if (picker) {
      picker.addEventListener('change', function () {
        var opts = [];
        $$('fieldset', picker).forEach(function (fs, i) {
          var c = $('input:checked', fs);
          opts[i] = c ? c.value : null;
          var lbl = $('[data-option-selected="' + i + '"]', picker);
          if (lbl && c) lbl.textContent = c.value;
        });
        var v = product.variants.find(function (x) {
          return x.options.every(function (o, i) { return o === opts[i]; });
        });
        currentVariant = v || null;
        if (!v) { setAvailability(null); return; }
        variantInput.value = v.id;
        updatePrice(v);
        updateStock(v);
        setAvailability(v);
        updateTierPrices();
        refreshSticky();
        if (v.featured_media && gallery) gallery.goToMedia(v.featured_media.id);
        if (document.body.classList.contains('template-product') && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    }

    function buildItems() {
      var items = [];
      var t = selectedTier();
      if (t && t.dataset.variantId) {
        items.push({ id: parseInt(t.dataset.variantId, 10), quantity: 1 });
      } else {
        items.push({ id: parseInt(variantInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 });
      }
      $$('[data-addon]:checked', form).forEach(function (a) { items.push({ id: parseInt(a.value, 10), quantity: 1 }); });
      return items;
    }

    function addToCart(goCheckout) {
      if (!currentVariant) return;
      if (errorEl) errorEl.hidden = true;
      var ok = false;
      atc.disabled = true;
      atc.classList.remove('is-added', 'is-shake');
      atc.classList.add('is-loading');
      if (atcText) atcText.textContent = SV.strings.adding;
      fetch(SV.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: buildItems() })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || SV.strings.error);
          if (goCheckout) { window.location.href = '/checkout'; return; }
          ok = true;
          Cart.open(true);
        })
        .catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          void atc.offsetWidth;
          atc.classList.add('is-shake');
        })
        .finally(function () {
          atc.classList.remove('is-loading');
          setAvailability(currentVariant);
          if (ok && !prefersReduced()) {
            atc.classList.add('is-added');
            if (atcText) atcText.textContent = SV.strings.added || 'Added';
            setTimeout(function () {
              atc.classList.remove('is-added');
              setAvailability(currentVariant);
            }, 1800);
          }
        });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(false); });
    if (buyNow) buyNow.addEventListener('click', function () { addToCart(true); });

    // Sticky add-to-cart
    if (stickyBar && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var past = !en.isIntersecting && en.boundingClientRect.top < 0;
          stickyBar.classList.toggle('is-visible', past);
          stickyBar.setAttribute('aria-hidden', past ? 'false' : 'true');
          var b = $('[data-sticky-btn]', stickyBar);
          if (b) b.tabIndex = past ? 0 : -1;
        });
      });
      io.observe(atc);
      var sbtn = $('[data-sticky-btn]', stickyBar);
      if (sbtn) sbtn.addEventListener('click', function () {
        if (sbtn.dataset.stickyMode === 'scroll' && bundles) {
          bundles.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          addToCart(false);
        }
      });
    }
  }

  /* ---------------- Cart drawer ---------------- */
  var Cart = {
    el: null,
    init: function () {
      this.el = $('[data-cart-drawer]');
      if (!this.el) return;
      var self = this;
      $$('[data-cart-close]', this.el).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      document.addEventListener('click', function (e) {
        var opener = e.target.closest('[data-cart-open]');
        if (opener && !document.body.classList.contains('template-cart')) { e.preventDefault(); self.open(true); }
      });
      $('[data-cart-items]', this.el).addEventListener('click', function (e) {
        var btn = e.target.closest('[data-line-change]');
        if (!btn) return;
        self.change(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      });
    },
    open: function (refresh) {
      if (!this.el) return;
      this.el.hidden = false;
      lockScroll(true);
      if (refresh) this.refresh();
    },
    close: function () {
      if (!this.el || this.el.hidden) return;
      this.el.hidden = true;
      lockScroll(false);
    },
    refresh: function () {
      var self = this;
      return fetch(SV.routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); return cart; });
    },
    change: function (key, qty) {
      var self = this;
      this.el.classList.add('is-loading');
      fetch(SV.routes.cartChange + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) { self.render(cart); })
        .finally(function () { self.el.classList.remove('is-loading'); });
    },
    render: function (cart) {
      var el = this.el;
      var prevCount = parseInt(($('[data-cart-count]') || {}).textContent, 10) || 0;
      $$('[data-cart-count]').forEach(function (c) { c.textContent = cart.item_count; c.classList.toggle('is-empty', cart.item_count === 0); });
      if (cart.item_count > prevCount && !prefersReduced()) {
        $$('[data-cart-count]').forEach(function (c) {
          c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
          var host = c.closest('.header__cart');
          if (host) { host.classList.remove('is-bump'); void host.offsetWidth; host.classList.add('is-bump'); }
        });
      }
      var lbl = $('[data-cart-count-label]', el);
      if (lbl) lbl.textContent = '(' + cart.item_count + ')';

      var body = $('[data-cart-items]', el);
      var foot = $('[data-cart-foot]', el);
      if (!cart.items.length) {
        body.innerHTML = '<div class="drawer__empty"><p>' + esc(SV.strings.empty) + '</p><a href="' + SV.routes.root + '" class="btn btn--accent">Continue shopping</a></div>';
        foot.hidden = true;
      } else {
        foot.hidden = false;
        body.innerHTML = cart.items.map(function (item) {
          var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
          var variant = item.product_has_only_default_variant ? '' : '<p class="d-line__variant">' + esc(item.variant_title) + '</p>';
          var discounts = (item.discounts || []).map(function (d) { return '<p class="d-line__disc">' + esc(d.title) + ' (−' + formatMoney(d.amount) + ')</p>'; }).join('');
          var was = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
          return '<div class="d-line">' +
            '<a class="d-line__img" href="' + esc(item.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
            '<div><a class="d-line__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' + variant + discounts +
              '<div class="d-line__qty">' +
                '<button type="button" aria-label="−" data-line-change data-key="' + esc(item.key) + '" data-qty="' + (item.quantity - 1) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
                '<span>' + item.quantity + '</span>' +
                '<button type="button" aria-label="+" data-line-change data-key="' + esc(item.key) + '" data-qty="' + (item.quantity + 1) + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
              '</div></div>' +
            '<div class="d-line__right"><p class="d-line__price">' + was + formatMoney(item.final_line_price) + '</p>' +
              '<button type="button" class="d-line__remove" data-line-change data-key="' + esc(item.key) + '" data-qty="0">' + esc(SV.strings.remove) + '</button></div>' +
          '</div>';
        }).join('');
      }

      var sub = $('[data-cart-subtotal]', el);
      if (sub) sub.textContent = formatMoney(cart.total_price);
      var savings = (cart.original_total_price || 0) - cart.total_price;
      var sRow = $('[data-cart-savings-row]', el);
      if (sRow) { sRow.hidden = savings <= 0; $('[data-cart-savings]', el).textContent = '−' + formatMoney(savings); }

      // Free shipping bar
      var bar = $('[data-ship-bar]', el);
      if (bar) {
        var threshold = parseInt(SV.freeShippingThreshold, 10) || 0;
        var text = $('[data-ship-text]', bar), fill = $('[data-ship-fill]', bar);
        if (!cart.items.length) { bar.hidden = true; }
        else {
          bar.hidden = false;
          if (threshold <= 0 || cart.total_price >= threshold) {
            text.textContent = SV.strings.freeShippingUnlocked;
            fill.style.width = '100%';
          } else {
            text.textContent = SV.strings.freeShippingRemaining.replace('[amount]', formatMoney(threshold - cart.total_price));
            fill.style.width = Math.min(100, Math.round(cart.total_price * 100 / threshold)) + '%';
          }
        }
      }
    }
  };
  SV.Cart = Cart;

  /* ---------------- Misc ---------------- */
  function initScrollToBuy() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-scroll-to-buy]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href !== '#MainContent' && href.charAt(0) !== '#') return;
      var target = $('[data-bundles]') || $('[data-pdp]');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  function initReviews(root) {
    $$('[data-reviews-more]', root).forEach(function (btn) {
      btn.onclick = function () {
        var sec = btn.closest('section');
        var hidden = $$('.review-card.is-hidden', sec);
        hidden.slice(0, 6).forEach(function (c) { c.classList.remove('is-hidden'); });
        if (hidden.length <= 6) btn.parentNode.hidden = true;
      };
    });
  }

  function initReveal(root) {
    if (!('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) return;
    var els = $$('.sec-head, .rich__inner, .col-card, .reel, .ps__card, .feature, .features__image, .it__media, .it__content, .step, .compare__table, .specs__media, .specs__content, .review-card, .guarantee__card, .faq__item', root);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el, i) {
      if (el.closest('.pdp')) return;
      el.classList.add('reveal');
      el.style.transitionDelay = (i % 3) * 80 + 'ms';
      io.observe(el);
    });
  }

  /* ---------------- Delivery timeline ---------------- */
  function addBusinessDays(date, days, skipWeekends) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (skipWeekends && (wd === 0 || wd === 6)) continue;
      added++;
    }
    return d;
  }
  function fmtDay(d) {
    var month = d.toLocaleDateString(document.documentElement.lang || 'en', { month: 'short' });
    var n = d.getDate();
    var sfx = 'th';
    if (n % 100 < 11 || n % 100 > 13) sfx = ({ 1: 'st', 2: 'nd', 3: 'rd' })[n % 10] || 'th';
    return month + ' ' + n + ((document.documentElement.lang || 'en').indexOf('en') === 0 ? sfx : '');
  }
  function initDelivery(root) {
    $$('[data-delivery]', root).forEach(function (el) {
      var skip = el.dataset.skipWeekends === 'true';
      var now = new Date();
      var r1 = addBusinessDays(now, parseInt(el.dataset.readyMin, 10) || 0, skip);
      var r2 = addBusinessDays(now, parseInt(el.dataset.readyMax, 10) || 0, skip);
      var d1 = addBusinessDays(now, parseInt(el.dataset.delMin, 10) || 0, skip);
      var d2 = addBusinessDays(now, parseInt(el.dataset.delMax, 10) || 0, skip);
      var range = function (a, b) {
        if (a.getTime() === b.getTime()) return fmtDay(a);
        if (a.getMonth() === b.getMonth()) return fmtDay(a) + ' – ' + fmtDay(b).replace(/^\S+\s/, '');
        return fmtDay(a) + ' – ' + fmtDay(b);
      };
      var o = $('[data-delivery-date="ordered"]', el), r = $('[data-delivery-date="ready"]', el), d = $('[data-delivery-date="delivered"]', el);
      if (o) o.textContent = fmtDay(now);
      if (r) r.textContent = range(r1, r2);
      if (d) d.textContent = range(d1, d2);
      el.classList.add('is-ready');
    });
  }

  /* ---------------- Testimonial rotator ---------------- */
  function initQuotes(root) {
    $$('[data-quotes]', root).forEach(function (wrap) {
      if (wrap.dataset.init) return;
      wrap.dataset.init = '1';
      var items = $$('[data-quote]', wrap), dots = $$('.quotes__dot', wrap);
      if (items.length < 2) return;
      var i = 0, timer;
      function show(n) {
        items[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
      }
      function start() { timer = setInterval(function () { show(i + 1); }, 5000); }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { clearInterval(timer); show(n); start(); }); });
      wrap.addEventListener('mouseenter', function () { clearInterval(timer); });
      wrap.addEventListener('mouseleave', function () { clearInterval(timer); start(); });
      start();
    });
  }

  /* ---------------- Video reels ---------------- */
  function initReels(root) {
    var vids = $$('.reel video', root);
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true; v.setAttribute('muted', ''); v.playsInline = true;
      var card = v.closest('.reel');
      v.addEventListener('playing', function () { if (card) card.classList.add('is-playing'); });
      v.addEventListener('pause', function () { if (card) card.classList.remove('is-playing'); });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target;
          if (en.isIntersecting) {
            if (v.preload === 'none') v.preload = 'auto';
            var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
          } else { v.pause(); }
        });
      }, { threshold: 0.35 });
      vids.forEach(function (v) { io.observe(v); });
    }
    $$('[data-reel-sound]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = $('video', btn.closest('.reel'));
        if (!v) return;
        var turnOn = v.muted;
        vids.forEach(function (o) { if (o !== v) { o.muted = true; var b = $('[data-reel-sound]', o.closest('.reel')); if (b) { b.classList.remove('is-on'); b.setAttribute('aria-label', b.dataset.off); } } });
        v.muted = !turnOn;
        if (turnOn) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        btn.classList.toggle('is-on', turnOn);
        btn.setAttribute('aria-label', turnOn ? btn.dataset.on : btn.dataset.off);
      });
    });
  }

  function initAll(root) {
    root = root || document;
    initDelivery(root);
    initQuotes(root);
    initReels(root);
    initCountdowns(root);
    $$('[data-pdp]', root).forEach(function (p) { initProduct(p); });
    initReviews(root);
    initReveal(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    initRotator();
    initRipple();
    Cart.init();
    initScrollToBuy();
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initMenu();
    initRotator();
    initAll(e.target);
  });
})();
